import LrmModule from "pages/Modules/LrmModule";
import ThorModule from "pages/Modules/ThorModule";
import UsersManagementModule from "pages/Modules/UsersManagementModule";
import React from "react";

export interface IRoute {
    path: string;
    component: React.ComponentType;
    exact?: boolean;
}
export enum RouteNames {
    LRM = "/lrm",
    THoR = "/thor",
    Users = "/users",
    NoMatch = "*",
}

export const globalRoutes: IRoute[] = [
    { path: RouteNames.LRM, exact: false, component: LrmModule },
    { path: RouteNames.THoR, exact: false, component: ThorModule },
    { path: RouteNames.Users, exact: false, component: UsersManagementModule },
];
